/*
 * @Author: gaojinyu 1593026814@qq.com
 * @Date: 2023-07-18 16:21:38
 * @LastEditors: gaojinyu 1593026814@qq.com
 * @LastEditTime: 2023-07-18 17:10:19
 * @FilePath: \north\src\mixins\nowTime.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */

import dayjs from "dayjs";
// 定义一个 mixin 对象
const nowTimeMixin = {
  data() {
    return {
      // 定义 mixin 中的数据属性
      nowTime: "",
      week:''
    };
  },
  methods: {
    // 关闭dislog
    close() {
      this.dialogVisible = false;
    },
    updateTime() {
      setInterval(() => {
        this.nowTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },
    getWeek(num) {
      var datas = dayjs().day();
      var week = ["日", "一", "二", "三", "四", "五", "六"];
      this.week = "星期" + week[datas];
      return "星期" + week[datas];
    },
  },
  created() {
    this.updateTime();
    this.getWeek()
    // mixin 中的生命周期钩子
    console.log("Mixin created");
  },
};

export default nowTimeMixin;
